import React from 'react';
import { graphql } from 'gatsby';
import { OmTabsTwoColumnLayoutImageRight } from '@om/component-library-react';
import TwoColumnImageRightV2 from './TwoColumnImageRightV2';

const TabsTwoColumnImageRightV2 = ({
    tabsTwoColumnImageRightV2Content,
    slot
}) => {
    if(!tabsTwoColumnImageRightV2Content) {
        return '';
    }

    const {
        use_heading_as_h1,
        is_extended,
        has_boundary,
        section_heading,
        section_caption,
        tab_text_one,
        two_column_image_right_v2_one,
        tab_text_two,
        two_column_image_right_v2_two,
        tab_text_three,
        two_column_image_right_v2_three,
        tab_text_four,
        two_column_image_right_v2_four,
        tab_text_five,
        two_column_image_right_v2_five,
        tab_text_six,
        two_column_image_right_v2_six,
        button_action_type,
        button_text,
        button_url,
        open_tab,
        call_me_back,
    } = tabsTwoColumnImageRightV2Content;

    return (
        <OmTabsTwoColumnLayoutImageRight
            slot={slot}
            isExtended={is_extended}
            hasBoundary={has_boundary}
            tabTextOne={tab_text_one}
            tabTextTwo={tab_text_two}
            tabTextThree={tab_text_three}
            tabTextFour={tab_text_four}
            tabTextFive={tab_text_five}
            tabTextSix={tab_text_six}
            buttonText={button_text}
            buttonUrl={button_url ? button_url.href : ''}
            buttonActionType={button_action_type}
            callMeBackObject={call_me_back ? JSON.stringify(call_me_back) : ''}
            openTab={open_tab}
        >
            {
                use_heading_as_h1 ? <h1 slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} /> :  <span slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} />
            }
            {
                section_caption ? <span slot="section-caption" dangerouslySetInnerHTML={{__html: section_caption}} /> : ''
            }
            <TwoColumnImageRightV2 slot="two-column-image-right-one" twoColumnImageRightContent={two_column_image_right_v2_one[0]} />
            <TwoColumnImageRightV2 slot="two-column-image-right-two" twoColumnImageRightContent={two_column_image_right_v2_two[0]} />
            <TwoColumnImageRightV2 slot="two-column-image-right-three" twoColumnImageRightContent={two_column_image_right_v2_three[0]} />
            <TwoColumnImageRightV2 slot="two-column-image-right-four" twoColumnImageRightContent={two_column_image_right_v2_four[0]} />
            <TwoColumnImageRightV2 slot="two-column-image-right-five" twoColumnImageRightContent={two_column_image_right_v2_five[0]} />
            <TwoColumnImageRightV2 slot="two-column-image-right-six" twoColumnImageRightContent={two_column_image_right_v2_six[0]} />
        </OmTabsTwoColumnLayoutImageRight>
    );
};

export const pageQuery = graphql`
fragment TabsTwoColumnLayoutImageRightV2 on Contentstack_tabs_two_column_layout_image_right_v2 {
        uid
        use_heading_as_h1
        is_extended
        has_boundary
        section_heading
        section_caption
        tab_text_one
        two_column_image_right_v2_one {
            ...TwoColumnImageRightV2
        }
        tab_text_two
        two_column_image_right_v2_two {
            ...TwoColumnImageRightV2
        }
        tab_text_three
        two_column_image_right_v2_three {
            ...TwoColumnImageRightV2
        }
        tab_text_four
        two_column_image_right_v2_four {
            ...TwoColumnImageRightV2
        }
        tab_text_five
        two_column_image_right_v2_five {
            ...TwoColumnImageRightV2
        }
        tab_text_six
        two_column_image_right_v2_six {
            ...TwoColumnImageRightV2
        }
        button_action_type
        button_text
        button_url {
            ...Link
        }
        open_tab
        call_me_back {
            ...CallMeBack
        }
    }
`;

export default TabsTwoColumnImageRightV2;
